module.exports = __webpack_public_path__ + "static/media/woocommerce-widget.542ec323.png";